import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ProjectService} from '../../shared/services/project/project.service';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {StatesService} from '../../shared/services/state/states.service';
import {Subscription} from 'rxjs/index';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {ProjectExportCsvComponent} from '../project/project-export-csv/project-export-csv.component';
import {ProjectLastMeasureComponent} from '../project/project-last-measure/project-last-measure.component';
import {IconService} from '../../shared/services/icon/icon.service';
import {AbstractMatTable} from '../../shared/classes/mat-table/abstract-mat-table';
import {AuthenticationService} from '../../shared/services/authentication/authentication.service';

@Component({
  selector: 'app-project',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent extends AbstractMatTable implements OnInit, OnDestroy {

  public levelSubscription: Subscription;
  public reloadProjectList: Subscription;
  public activeProject: boolean = true;


  constructor(private projectsService: ProjectService,
              public statesService: StatesService,
              public iconService: IconService,
              private translate: TranslateService,
              private matDialog: MatDialog,
              public authenticationService: AuthenticationService) {
    super();
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.levelSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.getProjects()
      );
    this.reloadProjectList = this.statesService.reloadListProject
      .subscribe(() => this.getProjects()
      );
    this.getProjects();

  }

  ngOnDestroy() {
    this.levelSubscription.unsubscribe();
    this.reloadProjectList.unsubscribe();
  }

  isNumber(value: any): boolean {
    return isNaN(parseInt(value));
  }

  propertyExists(property) {
    return property !== undefined;
  }

  openLink(url = null) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  reLoadList() {
    this.activeProject = !this.activeProject;
    this.statesService.reloadListProject.next();
  }

  getIconStatus() {
    return this.iconService.faArchive;
  }

  getActiveTextForSlider() {
    let value: string = '';
    this.translate.get(this.activeProject ? 'PROJECT_ACTIVE' : 'PROJECT_INACTIVE').subscribe((text: string) => {
      value = text;
    });
    return value;
  }

  openExportCsvModal(idProject, start_date, end_date) {
    const data = {
      start_date,
      end_date,
      idProject
    };
    this.matDialog.open(ProjectExportCsvComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }

  openLastMeasureModal(idProject) {
    const data = {
      idProject
    };
    this.matDialog.open(ProjectLastMeasureComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }

  /**
   *
   * @param idProject
   */
  downloadDevicesAsCsv(idProject: number) {
    const url: string = environment.apiUrl + environment.guardedRoute + `auth/export/devices/project/` + idProject + `?token=` + this.authenticationService.getToken();
    window.open(url, '_blank');
  }

  private getProjects() {
    this.setMatTable(this.projectsService.getProjects(this.activeProject),
      ['id', 'code', 'name', 'address', 'start_date', 'end_date', 'archive', 'project_device_locations_count', 'project_device_assignements_count', 'bad_note', 'action']);
  }


}
